export default __webpack_public_path__ + "static/media/valjak.493a5e59.jpg";